import script from "./betalingsSide.vue?vue&type=script&setup=true&lang=js"
export * from "./betalingsSide.vue?vue&type=script&setup=true&lang=js"

import "./betalingsSide.vue?vue&type=style&index=0&id=bb657b04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb657b04"]])

export default __exports__